<div class="modal-header">
    <h4>Add User</h4>
    <a class="close-icon" href="javascript:void()" (click)="closeClick()" ngbAutofocus><i class="flaticon2-cross"></i></a>
</div>
<div class="modal-body output-lable new-user">
    <div class="row">
        <div class="col-md-12" style="padding: 15px">
            <h5>Search and add Users</h5>
            <div class="search-wrapper">
                <mat-form-field class="search_field">
                    <input
                        matInput
                        type="text"
                        name="searchInput"
                        placeholder="search"
                        autocomplete="off"
                        (keyup)="searchResult($event)"
                        [(ngModel)]="searchInput"
                    />
                    <button mat-button matPrefix mat-icon-button class="search_btn">
                        <mat-icon class="serach_icon">search</mat-icon>
                    </button>
                </mat-form-field>
            </div>

            <div class="user_list">
                <ng-container *ngIf="searchInput">
                    <ul #userCard>
                        <li
                            class="user-card"
                            id="user-{{ i }} {{ user.firstName }}"
                            *ngFor="let user of usersList; let i = index"
                            (click)="selectUser(user, i)"
                        >
                            <div class="user_img_sec">
                                <!-- <ngx-avatars
                                    name="{{ user.firstName }}  {{ user.lastName }}"
                                    initialsSize="3"
                                    class="avatar"
                                    size="35"
                                    bgColor="#ffcc01"
                                    fgColor="#010101"
                                ></ngx-avatars> -->
                                <div
                                    class="custom-avatar avatar"
                                    [ngStyle]="{
                                        width: '35px',
                                        height: '35px',
                                        backgroundColor: '#ffcc01',
                                        color: '#010101',
                                        fontSize: '14px',
                                    }"
                                >
                                    {{ getInitials(user.firstName + ' ' + user.lastName) }}
                                </div>
                            </div>
                            <div class="user_details_sec">
                                <p>
                                    {{ user.firstName }} {{ user.lastName }} <span>{{ user.email }}</span>
                                </p>
                            </div>
                        </li>
                    </ul>
                </ng-container>
            </div>
            <div>
                <div *ngIf="usersList.length <= 0 && searchInput" class="error-message">No data matching "{{ searchInput }}"</div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn secondary-ebtn" (click)="closeClick()">Cancel</button>
                <button type="button" class="btn primary-ebtn" (click)="addClick()">Add</button>
            </div>
        </div>
    </div>
</div>
